export default __webpack_public_path__ + "static/media/color-icons_Distributors.8960f13f.svg";